export default "__VITE_ASSET__Bvj3ZSnD__"